import React, { useContext, useState } from 'react';
import GlobalContext from './contexts/GlobalContext';
import CAF from './modals/caf';
import CoachingBarContainer from './components/CoachingBar/CoachingBarContainer';
import SMSContainer from './components/SMSContainer/SMSContainer';

const CommonContainer = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const [isCAFEnabled, setIsCAFEnabled] = useState(globalContext.gb.liquid.settings.enable_caf_flow);
  const gb = globalContext?.gb;
  const liquid = gb?.liquid;
  const showSMSService = liquid?.settings?.showSMSService;
  const isReactPage = window.isPageMigratedToReact();
  const showCoachingBar = isReactPage && globalContext.customer?.isSubscriber() && globalContext.gb.liquid.template !== 'page.cancel-subscription';

  return (
    <>
    {isCAFEnabled && <CAF/>}
    {showCoachingBar && <CoachingBarContainer/>}
    {
      globalContext?.customer?.uuid ? <>{
        showSMSService && isReactPage && <SMSContainer />
      }
      </> : <></>
    }
    </>
  );
};

export default CommonContainer;
